module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      C. R. May\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("C.R. May is the author of more than a dozen novels set in early medieval and ancient Europe.")]), _c('P', [_vm._v("Before becoming a full-time writer he worked as a city trader, single-handedly renovated a Victorian townhouse and medieval hall, and added stay-at-home dad to his roll call of misadventures.")]), _c('P', [_vm._v("Born in London and raised in Essex, he now lives with his family near the Suffolk coast.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/k5Z8zM/tc-custom/9781800324527.jpg?1726519129314",
      "alt": "This image is the cover for the book Nemesis, Conquerors of Rome"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Nemesis, Conquerors of Rome\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("None can escape the judgement of Nemesis.")]), _c('p', [_vm._v("390BC. A winter has passed since the Gauls crossed the mountains to crush an Etruscan army outside Clusium.")]), _c('p', [_vm._v("Now, determined to avenge a death by the hand of a Roman observer, Brennus plans a terrible revenge.")]), _c('p', [_vm._v("Confident in the might of their arms, the Romans march to drive away the threat. But the battle goes horribly wrong. Overwhelmed by the ferocious brutality of the Senone warriors, the citizen army is routed.")]), _c('p', [_vm._v("Defenceless, Rome faces the judgement of the goddess Nemesis, and as the mournful howl of barbarian war horns draw closer, the druid Catumanda begins to understand the odyssey may cost her life… ")]), _c('p', [_c('b', [_vm._v("The epic tale of the first sack of Rome reaches its climactic conclusion. A thrilling tale perfect for fans of Simon Scarrow and S.J.A. Turney.")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Digital Publishing Limited\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0